"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "castel-d-azzano": {
    "5f2ea377": [{
      "hkey": "7b85d695",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "azzano": [{
      "hkey": "7b85d695",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "6b006a69": [{
      "hkey": "7b85d695",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "beccacivetta": [{
      "hkey": "7b85d695",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "castel-d-azzano"
    }],
    "838bf857": [{
      "hkey": "7b85d695",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "san-martino": [{
      "hkey": "7b85d695",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "castel-d-azzano"
    }]
  }
};
exports["default"] = _default;